var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-logo",
    transform: "translate(10933 5978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17761",
    "data-name": "Rectangle 17761",
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(-10933 -5978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29272",
    "data-name": "Path 29272",
    d: "M308.592,1670.277l6.956-8.117.347-.41h-2.311l-.071.078-5.948,6.946-4.736-6.917-.071-.107h-6.243l.262.38,7.318,10.693-7.3,8.517-.347.41h2.311l.07-.078,6.293-7.346,5.011,7.317.071.107h6.243l-.262-.381Zm2.646,9.776-5.008-7.19h0l-.045-.068-.752-1.083-5.717-8.2h1.993l4.759,6.839h0l.752,1.073h0l6.01,8.634Z",
    transform: "translate(-11219.447 -7629.75)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter__icon.7c4371d9f1fcb2ea2f481f11a59d6bdc.svg";
export { ForwardRef as ReactComponent };